import React, { Component } from "react";
import {
  main_url,
  stopSaving,
  startSaving,
  getBranch,
  getCookieData,
  getWithdrawalLocation,
} from "../../../utils/CommonFunction";
import "react-toastify/dist/ReactToastify.min.css";
import { toast } from "react-toastify";
import { getHeaders } from "../../../utils/apiHelper";
import moment from "moment";
import Select from "react-select";
import DatePicker from "react-datetime";
import { getUserId, validate, fno } from "../../../utils/CommonFunction";
const $ = require("jquery");
var form_validate = true;
var saveBtn = false;
export default class TravelAdvancedClaimAddNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_info: getCookieData("user_info"),
      fileArray: [],
      newDoc: [],
      advanceData: props.data[0],
      branch: [],
      selected_location: [],
      claimData: {
        actual_date: new Date(),
        start_location: "",
        destination: "",
        start_time: new Date(),
        end_time: new Date(),
        noOfDays: 1,
        noOfNights: 0,
        meals: 0,
        lodging: 0,
        transport: 0,
        amount: 0,
      },
      data: {
        withdraw_location: 0,
        user_id: getUserId("user_info"),
        selectedRequest: "",
        actual_amount: 0,
        purpose: "",
        remark: "",
        settle_amount: 0,
        advancedNo: props.data[0].form_no,
        advancedId: props.data[0].travel_allowance_id,
      },
      dataSource: [],
      holidays: [], // Added by LMM (22 Aug 2024)
    };
  }

  // Added by LMM to make Remark field "required" when Travel Advanced is overdue (22 Aug 2024)
  isOverdue = () => {
    if (this.state.dataSource.length < 1) return false;
    let lastTravelDate;
    this.state.dataSource.forEach((data) => {
      const endDate = new Date(data.actual_date.toString()); // Start from actual date (Start Date)
      endDate.setDate(endDate.getDate() + data.noOfDays * 1 - 1); // Add the number of days to it to get End Date
      if (!lastTravelDate) {
        lastTravelDate = new Date(endDate.toString());
      } else if (lastTravelDate < endDate) {
        // Take the most recent End Date
        lastTravelDate = new Date(endDate.toString());
      }
    });

    // Start generating a list of dates between Last Travel Date and Current Date.
    const travelDateList = [];
    const startCountDate = new Date(lastTravelDate.toString());
    startCountDate.setDate(startCountDate.getDate() + 1); // Start counting from the next day
    for (
      const date = startCountDate;
      date <= new Date();
      date.setDate(date.getDate() + 1)
    ) {
      const currentDate = new Date(date.toString());

      var dayOfWeek = currentDate.getDay();
      if (dayOfWeek === 6 || dayOfWeek === 0) continue; // Skip Sat and Sun (Weekends)
      travelDateList.push(currentDate);
    }

    const numberOfWorkingDaysAfterTravelEndDate = travelDateList.filter(
      (travelDate) =>
        // Remove public holidays
        !this.state.holidays.find((holiday) => {
          return (
            holiday.getFullYear() === travelDate.getFullYear() &&
            holiday.getMonth() === travelDate.getMonth() &&
            holiday.getDate() === travelDate.getDate()
          );
        })
    ).length;
    return numberOfWorkingDaysAfterTravelEndDate > 3; // Overdue after three days
  };

  async componentDidMount() {
    let that = this;
    const withdrawalLocations = await getWithdrawalLocation();
    const holidaysList = await this.getHolidaysAroundYear();
    that.setState({
      branch: withdrawalLocations,
      holidays: holidaysList,
    });

    // Added by to set user's branch and withdraw location to equal
    let user_branch = parseInt(this.state.user_info.branch_id);
    let data = this.state.data;
    data.withdraw_location = user_branch ? user_branch : 0;
    let selected_location = user_branch
      ? this.state.branch.filter((item) => {
          return item.value === user_branch;
        })
      : 0;
    this.setState({
      selected_location: selected_location,
      data: data,
    });
    // Added end 2024-01-29

    $(document).on("click", "#toRemove", function () {
      var data = $(this).find("#remove").text();
      data = $.parseJSON(data);

      var advanceData = $(this).find("#removeData").text();
      advanceData = $.parseJSON(advanceData);

      let newData = that.state.dataSource;
      newData.splice(data, 1);

      let claimData = that.state.data;
      var totalAmount = 0;
      var settleAmount = 0;

      for (var i = 0; i < newData.length; i++) {
        totalAmount += newData[i].amount;
      }

      claimData.actual_amount = totalAmount;

      settleAmount = advanceData - totalAmount;
      claimData.settle_amount = settleAmount;
      that.setState(
        {
          dataSource: newData,
          data: claimData,
        },
        () => that.setDataTable(newData)
      );
    });
  }

  componentDidUpdate() {
    if (!form_validate) validate("check_form");
  }

  async getHolidaysAroundYear() {
    const res = await fetch(`${main_url}holidaySetup/getHolidaysAroundYear`, {
      headers: getHeaders(),
    });
    const data = await res.json();
    const holidaysList = [];
    data.forEach((holiday) => {
      const startDate = new Date(holiday.start_date);
      const endDate = new Date(holiday.end_date);
      for (
        const date = startDate;
        date <= endDate;
        date.setDate(date.getDate() + 1)
      ) {
        const currentDate = new Date(date.toString());
        holidaysList.push(currentDate);
      }
    });
    return holidaysList;
  }

  changePurpose = (e) => {
    let data = this.state.claimData;
    data.purpose = e.target.value;
    this.setState({
      claimData: data,
    });
  };

  changeactual_date(value) {
    let data = this.state.claimData;
    data.actual_date = value;
    this.setState({
      claimData: data,
    });
  }
  changeStartTime(value) {
    let data = this.state.claimData;
    data.start_time = value;
    this.setState({
      claimData: data,
    });
  }
  changeEndTime(value) {
    let data = this.state.claimData;
    data.end_time = value;
    this.setState({
      claimData: data,
    });
  }

  changeWithdrawLocation = (e) => {
    let data = this.state.data;
    data.withdraw_location = e.value;
    this.setState({
      selected_location: e,
      data: data,
    });
  };

  changeRemark = (e) => {
    let data = this.state.data;
    data.remark = e.target.value;
    this.setState({
      data: data,
    });
  };

  claimChangeText = (e) => {
    let data = this.state.claimData;
    let name = e.target.dataset.name;
    data[name] = e.target.value;

    if (name === "meals" || name === "transport" || name === "lodging") {
      data.amount =
        Number(data.meals) + Number(data.transport) + Number(data.lodging);
    }
    this.setState({
      claimData: data,
    });
  };

  addData = (e) => {
    if (validate("check_form")) {
      var data = this.state.dataSource;
      var totalAmount = 0;
      var settleAmount = 0;

      data.push(this.state.claimData);
      this.setState({
        dataSource: data,
      });

      for (var i = 0; i < data.length; i++) {
        totalAmount += data[i].amount;
      }
      console.log(this.state.advanceData.advanced_amount);
      console.log(totalAmount);
      settleAmount = this.state.advanceData.advanced_amount - totalAmount;

      let claimData = this.state.data;
      claimData.settle_amount = settleAmount;
      claimData.actual_amount = totalAmount;
      saveBtn = true;
      form_validate = true;
      this.setDataTable(data);
      this.setState({
        claimData: {
          actual_date: new Date(),
          start_location: "",
          destination: "",
          start_time: new Date(),
          end_time: new Date(),
          noOfDays: "",
          noOfNights: "",
          meals: 0,
          lodging: 0,
          transport: 0,
          amount: 0,
          purpose: "",
        },
        data: claimData,
      });
    } else {
      form_validate = false;
    }
  };

  setDataTable(data) {
    // console.log('advance daa ===> ', this.state.advanceData)

    var table;
    if ($.fn.dataTable.isDataTable("#dataTables-claimTable")) {
      table = $("#dataTables-claimTable").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-claimTable").empty();
    }
    var l = [];
    for (var i = 0; i < data.length; i++) {
      const index = i;
      const obj = {
        actual_date: moment(data[i].actual_date).format("DD-MM-YYYY"),
        start_location: data[i].start_location,
        destination: data[i].destination,
        start_time: moment(data[i].start_time).format("h:mm a"),
        end_time: moment(data[i].end_time).format("h:mm a"),
        noOfDays: data[i].noOfDays,
        noOfNights: data[i].noOfNights,
        meals: data[i].meals,
        lodging: data[i].lodging,
        transport: data[i].transport,
        amount: data[i].amount,
        // purpose: data[i].purpose,
        purpose: data[i].purpose ? data[i].purpose : "",
        action:
          '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toRemove" ><span id="remove" class="hidden" >' +
          index +
          '</span> <span id="removeData" class="hidden">' +
          this.state.advanceData.advanced_amount +
          '</span>  <i className="fa fa-cogs"></i>&nbsp;Remove</button>',
      };

      l.push(obj);
    }

    table = $("#dataTables-claimTable").DataTable({
      autofill: false,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: false,
      buttons: false,

      data: l,
      columns: [
        { title: "Actual Date", data: "actual_date" },
        { title: "Start Location", data: "start_location" },
        { title: "Destination", data: "destination" },
        { title: "Start Time", data: "start_time" },
        { title: "End Time", data: "end_time" },
        { title: "No Of Days", data: "noOfDays" },
        { title: "No Of Nights", data: "noOfNights" },
        { title: "Meals", data: "meals" },
        { title: "Lodging", data: "lodging" },
        { title: "Transport", data: "transport" },
        { title: "Amount", data: "amount" },
        { title: "Purpose", data: "purpose" },
        { title: "Action", data: "action" },
      ],
    });
  }

  // handlefileChanged(event) {
  //     console.log(event.target.files)
  //     event.preventDefault();

  //     let arr = [];
  //     let url = [];
  //     for (let i = 0; i < event.target.files.length; i++) {
  //         let reader = new FileReader();
  //         let getfile = event.target.files[i];
  //         reader.onloadend = (r) => {
  //             url.push(r.target.result);
  //         }
  //         reader.readAsDataURL(getfile);
  //         arr.push(getfile);

  //     }
  //     document.getElementById('travelDropzone').value = ''
  //     this.setState({
  //         fileArray: arr
  //     })

  // }
  removeNewDocument(index, event) {
    var array = this.state.fileArray;

    array.splice(index, 1);
    this.setState({
      fileArray: array,
    });
  }

  checkFiles(e) {
    var files = document.getElementById("travelDropzone").files;

    if (files.length > 2) {
      toast.warning("You can only upload a maximum of 2 files!");
    }

    let fileArray = this.state.fileArray;
    var obj = document.querySelector("#travelDropzone").files.length;
    for (var i = 0; i < obj; i++) {
      var getfile = document.querySelector("#travelDropzone").files[i];
      fileArray.push(getfile);
    }
    document.getElementById("travelDropzone").value = "";
    this.setState({
      // attachment: attachment,
      fileArray: fileArray,
    });
  }

  check = () => {
    if (this.state.dataSource.length === 0) {
      return toast.error("Travel detail cannot be empty.");
    }
    // Added by LMM to make Remark field "required" when Travel Advanced is overdue (19 Aug 2024)
    if (this.isOverdue() && !this.state.data.remark.trim()) {
      return toast.error(
        "Please provide a remark for the overdue travel claim."
      );
    }
    if (this.state.fileArray.length == 0) {
      toast.error("Please Choose Attachment File!");
    } else {
      if (saveBtn) {
        $("#saving_button").attr("disabled", true);
        this.props.addTravelAdvancedClaim(
          this.state.dataSource,
          this.state.data,
          this.state.advanceData.advanced_amount,
          this.state.fileArray
        );
      } else {
        startSaving();
        toast.error(" Please Add Full Information", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  render() {
    return (
      <div className="row wrapper border-bottom white-bg">
        <div className="margin-top-20">
          <div className="form-horizontal" name="demo-form">
            <div className="col-md-6">
              <div className="form-group">
                <div>
                  <label className="col-sm-12">Request Type</label>
                </div>
                <div className="col-sm-10">
                  <input className="form-control" disabled value="Claim" />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <div>
                  <label className="col-sm-12">Advanced Number</label>
                </div>
                <div className="col-sm-10">
                  <input
                    className="form-control"
                    placeholder="Please Choose Advanced No"
                    value={fno.fno_travel + this.state.advanceData.form_no}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <h4>Advanced Information</h4>
              <div className="ibox float-e-margins">
                <div
                  className="ibox-content p-md"
                  style={{ float: "left", backgroundColor: "darkgrey" }}
                >
                  <div className="col-md-2">
                    <label>User</label>
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      value={this.state.advanceData.fullname}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Start Location</label>
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      value={this.state.advanceData.start_location}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Destination</label>
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      value={this.state.advanceData.destination}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Start Date</label>
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      value={this.state.advanceData.start_date}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>End Date</label>
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      value={this.state.advanceData.end_date}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>No Of Days</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={this.state.advanceData.noOfDays}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>No Of Nights</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={this.state.advanceData.noOfNights}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Meals</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={
                        this.state.advanceData.meals != 0
                          ? this.state.advanceData.meals
                          : 0
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Lodging</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={
                        this.state.advanceData.lodging != 0
                          ? this.state.advanceData.lodging
                          : 0
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Transport</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={
                        this.state.advanceData.transport != 0
                          ? this.state.advanceData.transport
                          : 0
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Total Amount</label>
                    <input
                      className="form-control"
                      type="number"
                      disabled
                      value={
                        this.state.advanceData.advanced_amount != 0
                          ? this.state.advanceData.advanced_amount
                          : 0
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12" id="check_form">
              <div className="ownspacing"></div>
              <h4>Claim Information</h4>
              <div className="ibox float-e-margins">
                <div className="ibox-content p-md">
                  <div className="row">
                    <div className="col-md-3">
                      <label>Actual Date</label>
                      <DatePicker
                        dateFormat="DD/MM/YYYY"
                        value={this.state.claimData.actual_date}
                        timeFormat={false}
                        onChange={this.changeactual_date.bind(this)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Start Location</label>
                      <input
                        className="form-control checkValidate"
                        type="text"
                        data-name="start_location"
                        value={this.state.claimData.start_location}
                        placeholder="Enter Start Location"
                        onChange={this.claimChangeText}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Destination</label>
                      <input
                        className="form-control checkValidate"
                        type="text"
                        data-name="destination"
                        value={this.state.claimData.destination}
                        placeholder="Enter Destination"
                        onChange={this.claimChangeText}
                      />
                    </div>
                  </div>
                  <div className="row margin-top-20">
                    <div className="col-md-3">
                      <label>Start Time</label>
                      <DatePicker
                        value={this.state.claimData.start_time}
                        dateFormat={false}
                        onChange={this.changeStartTime.bind(this)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>End Time</label>
                      <DatePicker
                        value={this.state.claimData.end_time}
                        dateFormat={false}
                        onChange={this.changeEndTime.bind(this)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>No Of Days</label>
                      <input
                        className="form-control checkValidate"
                        type="number"
                        data-name="noOfDays"
                        value={this.state.claimData.noOfDays}
                        placeholder="No Of Days"
                        onChange={this.claimChangeText}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>No Of Nights</label>
                      <input
                        className="form-control"
                        type="number"
                        data-name="noOfNights"
                        value={this.state.claimData.noOfNights}
                        placeholder="No Of Nights"
                        onChange={this.claimChangeText}
                      />
                    </div>
                  </div>
                  <div className="row margin-top-20">
                    <div className="col-md-3">
                      <label>Meals</label>
                      <input
                        className="form-control"
                        type="number"
                        data-name="meals"
                        value={this.state.claimData.meals}
                        placeholder="Enter Meals"
                        onChange={this.claimChangeText}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Lodging</label>
                      <input
                        className="form-control"
                        type="number"
                        data-name="lodging"
                        value={this.state.claimData.lodging}
                        placeholder="Enter Lodging"
                        onChange={this.claimChangeText}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Transport</label>
                      <input
                        className="form-control"
                        type="number"
                        data-name="transport"
                        value={this.state.claimData.transport}
                        placeholder="Enter Meals"
                        onChange={this.claimChangeText}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Total Amount</label>
                      <input
                        className="form-control input-md "
                        type="text"
                        disabled
                        data-name="amount"
                        value={this.state.claimData.amount}
                      />
                    </div>
                  </div>
                  <div className="row margin-top-20">
                    <div className="col-md-6">
                      <label>Purpose</label>
                      {/* checkValidate */}
                      <input
                        className="form-control input-md "
                        type="textarea"
                        data-name="purpose"
                        onChange={this.changePurpose}
                        value={this.state.claimData.purpose}
                      />
                    </div>

                    <div className="col-md-6 btn-rightend">
                      <button
                        className="btn-primary btn"
                        onClick={this.addData}
                        style={{ marginTop: 20 }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <table
                  width="99%"
                  className="table table-striped table-bordered table-hover responsive nowrap dt-responsive"
                  id="dataTables-claimTable"
                />
              </div>
              <div className="col-md-12">
                {/* <div className="col-md-3">
                                        <label>Purpose</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            data-name='purpose'
                                            value={this.state.data.purpose}
                                            placeholder="Enter Purpose"
                                            onChange={this.changePurpose}

                                        />
                                    </div> */}
                <div className="col-md-2">
                  <label>Advanced Amount</label>
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    value={this.state.advanceData.advanced_amount}
                  />
                </div>
                <div className="col-md-2">
                  <label>Actual Amount </label>
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    value={this.state.data.actual_amount}
                  />
                </div>
                <div className="col-md-2">
                  <label>Settle Amount</label>
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    value={this.state.data.settle_amount}
                  />
                </div>
                <div className="col-md-6">
                  <label>Withdrawal Location (Choose Claim Location)</label>
                  {this.state.selected_location &&
                  this.state.selected_location.length > 0 ? (
                    <Select
                      data-name="withdraw_loction"
                      value={this.state.selected_location}
                      onChange={this.changeWithdrawLocation}
                      options={this.state.branch}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                      // menuIsOpen={false}
                    />
                  ) : (
                    <Select
                      data-name="withdraw_loction"
                      value={this.state.selected_location}
                      onChange={this.changeWithdrawLocation}
                      options={this.state.branch}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  )}
                </div>
                <div className="col-md-6">
                  <label>
                    Remark
                    {this.isOverdue() && <span className="text-danger">*</span>}
                  </label>
                  <input
                    className="form-control input-md "
                    type="textarea"
                    data-name="remark"
                    onChange={this.changeRemark}
                    value={this.state.data.remark}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{
                marginTop: 30,
              }}
            >
              <input
                type="file"
                className="dropZone"
                id="travelDropzone"
                onChange={this.checkFiles.bind(this)}
                multiple
              />
            </div>
            <div>
              {this.state.fileArray.map((data, index) => (
                <div className="fileuploader-items col-md-4">
                  <ul className="fileuploader-items-list">
                    <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                      <div className="columns">
                        <div className="column-thumbnail">
                          <div className="fileuploader-item-image fileuploader-no-thumbnail">
                            <div
                              className="fileuploader-item-icon"
                              style={{ backgroundColor: "#3f4fd3" }}
                            >
                              <i>{data.name.split(".")[1]}</i>
                            </div>
                          </div>
                          <span className="fileuploader-action-popup"></span>
                        </div>
                        <div className="column-title">
                          <span className="own-text">{data.name}</span>
                        </div>
                        <div className="column-actions">
                          <a
                            className="fileuploader-action fileuploader-action-remove"
                            onClick={(event) =>
                              this.removeNewDocument(index, event)
                            }
                          >
                            {" "}
                            <i></i>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
            <div className="col-md-12 btn-rightend mt20">
              <button
                onClick={this.check.bind(this)}
                id="saving_button"
                className="btn btn-primary"
              >
                <span>Confirm</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
